/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './post-delivery-monitoring.reducer';

export const PostDeliveryMonitoringDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const postDeliveryMonitoringEntity = useAppSelector(state => state.postDeliveryMonitoring.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="postDeliveryMonitoringDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.postDeliveryMonitoring.detail.title">PostDeliveryMonitoring</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.postDeliveryMonitoring.id">Id</Translate>
            </span>
          </dt>
          <dd>{postDeliveryMonitoringEntity.id}</dd>
          <dt>
            <span id="dischargeDate">
              <Translate contentKey="tinyMedicRestApp.postDeliveryMonitoring.dischargeDate">Discharge Date</Translate>
            </span>
          </dt>
          <dd>{postDeliveryMonitoringEntity.dischargeDate}</dd>
          <dt>
            <span id="painScore">
              <Translate contentKey="tinyMedicRestApp.postDeliveryMonitoring.painScore">Pain Score</Translate>
            </span>
          </dt>
          <dd>{postDeliveryMonitoringEntity.painScore}</dd>
          <dt>
            <span id="comments">
              <Translate contentKey="tinyMedicRestApp.postDeliveryMonitoring.comments">Comments</Translate>
            </span>
          </dt>
          <dd>{postDeliveryMonitoringEntity.comments}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.postDeliveryMonitoring.active">Active</Translate>
            </span>
          </dt>
          <dd>{postDeliveryMonitoringEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.postDeliveryMonitoring.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{postDeliveryMonitoringEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.postDeliveryMonitoring.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{postDeliveryMonitoringEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.postDeliveryMonitoring.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{postDeliveryMonitoringEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.postDeliveryMonitoring.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{postDeliveryMonitoringEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.postDeliveryMonitoring.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{postDeliveryMonitoringEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postDeliveryMonitoring.patient">Patient</Translate>
          </dt>
          <dd>{postDeliveryMonitoringEntity.patient ? postDeliveryMonitoringEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postDeliveryMonitoring.recoveryRecord">Recovery Record</Translate>
          </dt>
          <dd>{postDeliveryMonitoringEntity.recoveryRecord ? postDeliveryMonitoringEntity.recoveryRecord.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postDeliveryMonitoring.pregnancy">Pregnancy</Translate>
          </dt>
          <dd>{postDeliveryMonitoringEntity.pregnancy ? postDeliveryMonitoringEntity.pregnancy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/post-delivery-monitoring" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/post-delivery-monitoring/${postDeliveryMonitoringEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PostDeliveryMonitoringDetail;
